import type { ApiClient } from './client'
import type { components } from '@aurigaengineering/contracts-admin'

export type AccountMatch = components['schemas']['AccountMatch']
export type AuditLine = components['schemas']['AuditView']

/** Support's side of the API (app:R22, R91): finding a Student, acting as them, and the Trail. */
export interface SupportApi {
  /** Accounts whose email holds the text, masked. At least three letters. */
  find(email: string): Promise<AccountMatch[]>
  /** Starts the grant; the App tab it opens then answers as this Student. */
  actAs(student: string): Promise<void>
  /** What was done as this Student, newest first. The Owner's alone. */
  trail(student: string): Promise<AuditLine[]>
}

export function supportApi(client: ApiClient): SupportApi {
  return {
    async find(email) {
      const { data, error } = await client.GET('/admin/accounts', { params: { query: { email } } })
      return data ?? failed(error)
    },

    async actAs(student) {
      const { error, response } = await client.POST('/admin/act-as/{student}', {
        params: { path: { student } },
      })
      if (!response.ok) failed(error ?? { title: response.status === 404 ? 'No such Student.' : undefined })
    },

    async trail(student) {
      const { data, error, response } = await client.GET('/admin/audit', {
        params: { query: { student, take: 100 } },
      })
      if (response.status === 403) failed({ title: 'The Audit Trail is the Owner’s to read.' })
      return data ?? failed(error)
    },
  }
}

function failed(error: unknown): never {
  const problem = error as { detail?: string; title?: string } | undefined

  throw new Error(problem?.detail ?? problem?.title ?? 'The API refused that.')
}
